import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

export const APP_ROUTES_PATH = {
  Restaurants_Home: 'restaurants',
  Booking_Home: 'booking-home',
  Order_Home: 'restaurants-with-order',
  Reload_Home: 'reload',
  History_Home: 'history-home',
  Account_Home: 'account',
};

const routes: Routes = [
  {
    path: '',
    redirectTo: APP_ROUTES_PATH.Restaurants_Home,
    pathMatch: 'full',
  },
  {
    path: APP_ROUTES_PATH.Account_Home,
    loadChildren: () => import('./features/account/account-home/account-home.module').then((m) => m.AccountHomePageModule),
  },
  {
    path: 'account/notifications',
    loadChildren: () => import('./features/account/notifications-home/notifications-home.module').then((m) => m.NotificationsHomePageModule),
  },
  {
    path: 'account/notifications-settings',
    loadChildren: () => import('./features/account/notifications-settings/notifications-settings.module').then((m) => m.NotificationsSettingsPageModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./features/authentication/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'sandbox',
    loadChildren: () => import('./features/sandbox/sandbox/sandbox.module').then((m) => m.SandboxPageModule),
  },
  {
    path: APP_ROUTES_PATH.Reload_Home,
    loadChildren: () => import('./features/reload/reload-account-balance/reload-account-balance.module').then((m) => m.ReloadAccountBalancePageModule),
  },
  {
    path: 'reload/success',
    loadChildren: () => import('./features/reload/reload-success/reload-success.module').then((m) => m.ReloadSuccessPageModule),
  },
  {
    path: 'reload/error',
    loadChildren: () => import('./features/reload/reload-error/reload-error.module').then((m) => m.ReloadErrorPageModule),
  },
  {
    path: 'dev-home',
    loadChildren: () => import('./features/account/dev-home/dev-home.module').then((m) => m.DevHomePageModule),
  },
  {
    path: APP_ROUTES_PATH.Restaurants_Home,
    loadChildren: () => import('./features/restaurants/restaurants-home/restaurants-home.module').then((m) => m.RestaurantsHomePageModule),
  },
  {
    path: 'restaurants/:id',
    loadChildren: () => import('./features/restaurants/restaurant-home/restaurant-home.module').then((m) => m.RestaurantHomePageModule),
  },
  {
    path: 'restaurants-with-order/:id',
    loadChildren: () => import('./features/restaurants/restaurant-home/restaurant-home.module').then((m) => m.RestaurantHomePageModule),
  },
  {
    path: 'registration',
    loadChildren: () => import('./features/registration/registration.module').then((m) => m.RegistrationPageModule),
  },
  {
    path: 'infos',
    loadChildren: () => import('./features/legal/infos/infos.module').then((m) => m.InfosPageModule),
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./features/authentication/reset-password/reset-password.module').then((m) => m.ResetPasswordPageModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./features/authentication/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordPageModule),
  },
  {
    path: 'confirm-email',
    loadChildren: () => import('./features/registration/confirm-email/confirm-email.module').then((m) => m.ConfirmEmailPageModule),
  },
  {
    path: 'login-sso',
    loadChildren: () => import('./features/authentication/login-sso/login-sso.module').then((m) => m.LoginSsoPageModule),
  },
  {
    path: 'link-account',
    loadChildren: () => import('./features/registration/link-account/link-account.module').then((m) => m.LinkAccountPageModule),
  },
  {
    path: APP_ROUTES_PATH.History_Home,
    loadChildren: () => import('./features/history/history-home/history-home.module').then((m) => m.HistoryHomePageModule),
  },
  {
    path: APP_ROUTES_PATH.Booking_Home,
    loadChildren: () => import('./features/booking/booking-home/booking-home.module').then((m) => m.BookingHomePageModule),
  },
  {
    path: APP_ROUTES_PATH.Order_Home,
    loadChildren: () => import('./features/restaurants/order-home/order-home.module').then((m) => m.OrderHomePageModule),
  },
  {
    path: 'animations/:id',
    loadChildren: () => import('./features/animations/animation-home/animation-home.module').then((m) => m.AnimationPageModule),
  },
  {
    path: 'account/animations',
    loadChildren: () => import('./features/animations/animations-home/animations-home.module').then((m) => m.AnimationsPageModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('./features/faq/faq-home/faq-home.module').then((m) => m.FaqHomePageModule),
  },
  {
    path: 'account/survey-chats',
    loadChildren: () => import('./features/account/survey-chats-home/survey-chats-home.module').then((m) => m.SurveyChatsPageModule),
  },
  {
    path: 'account/chats',
    loadChildren: () => import('./features/chat/chats-home/chats-home.module').then((m) => m.ChatsPageModule),
  },
  { path: '**', redirectTo: APP_ROUTES_PATH.Restaurants_Home },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
